import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import './Home.css';
import logo from './assets/images/logo.png';
import bg from './assets/images/bg_circuiti.jpg';

class Home extends Component {
    render() {
        return (
            <Grid item xs={12} id='home'>
                <Grid container>
                    <Grid item xs={12}>
                        <div className='header'>
                            <img src={logo} alt='Radio Gaga Logo' />
                            <h1 className='slide-title'>Radio Gaga<br /><span className='subtitle'>Centro assistenza tecnica autorizzata plurimarche</span></h1>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6} id='story'>
                        <div className='div-grid'>
                            <div className='text'>
                                <p>Radio Gaga opera da oltre 30 anni a supporto dei costruttori nell'area assistenza tecnica.</p>
                                <p>Vanta una considerevole esperienza nei settori dei sistemi di navigazione satellitare, prodotti per DJ, autoradio, TV al plasma, telefonia mobile e dell Hi-Fi domestico.</p>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6} id='circuiti'>
                        <div id='bg-circuiti'>
                            <img src={bg} alt='' />
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default Home;